import { logger } from "@/modules/logger";
import { AppStore } from "@/store";

// Reference: https://dexie.org/docs/DexieErrors/Dexie.QuotaExceededError
export function isQuotaExceededError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  if (error.name === "QuotaExceededError") {
    return true;
  }

  const isDexieError = "inner" in error;
  if (isDexieError) {
    const dexieError = error as Error & { inner?: Error };
    return dexieError.inner?.name === "QuotaExceededError";
  }

  return false;
}

export function handleQuotaExceededError(error: unknown, store: AppStore, context?: string): void {
  const errorMessage = error instanceof Error ? error.message : String(error);
  logger.error({
    message: context
      ? `[withDexieErrorHandling][QuotaExceededError] ${context}: ${errorMessage}`
      : `[withDexieErrorHandling][QuotaExceededError] ${errorMessage}`,
  });
  store.sync.handleDexieQuotaExceededError();
}

export async function withDexieErrorHandling<T>(
  operation: () => Promise<T>,
  store: AppStore,
  context?: string
): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    if (isQuotaExceededError(error)) {
      handleQuotaExceededError(error, store, context);
      throw error;
    }
    throw error;
  }
}
